import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import './UnsavedChangesModal.css';

function UnsavedChangesModal({ isActive, skipRef, message }) {
    const blocker = useBlocker(({ currentLocation, nextLocation }) => {
        if (skipRef?.current) {
            skipRef.current = false;
            return false;
        }
        return isActive && currentLocation.pathname !== nextLocation.pathname;
    });

    useEffect(() => {
        if (!isActive) return;
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [isActive]);

    if (blocker.state !== 'blocked') return null;

    return (
        <div className="ucm-overlay" onClick={() => blocker.reset()}>
            <div className="ucm-dialog" onClick={e => e.stopPropagation()}>
                <h2 className="ucm-title">Neuložené změny</h2>
                <p className="ucm-message">
                    {message ?? 'Pokud odejdete, přijdete o svůj postup. Opravdu chcete odejít?'}
                </p>
                <div className="ucm-actions">
                    <button className="ucm-btn-stay" onClick={() => blocker.reset()}>
                        Zůstat
                    </button>
                    <button className="ucm-btn-leave" onClick={() => blocker.proceed()}>
                        Odejít
                    </button>
                </div>
            </div>
        </div>
    );
}

export default UnsavedChangesModal;
